import React from 'react'
import { ExternalLink, LoaderCircle, Phone } from 'lucide-react'
import { cn } from '@/lib/utils'
import store from '../../state/store'

const BTN_CLASS = 'inline-flex h-10 cursor-pointer items-center justify-center border-0 bg-[#3ecf8e] px-3.5 text-sm font-semibold tracking-wide text-white hover:bg-[#3ecf8e]/90'
const HIGHLIGHT_CLASS = 'bg-[gold] text-black hover:bg-[gold]/90'

class BacklogClaimButton extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      highlighted: (((this.props.backlog || {}).next_item || {}).highlight || '').length > 0
    }
  }

  componentWillReceiveProps(nextProps) {
    const highlighted = (((nextProps.backlog || {}).next_item || {}).highlight || '').length > 0

    if (highlighted) {
      if (!this.state.highlighted) {
        store.emit('media:sound:play')
      }
    }

    this.setState({highlighted: highlighted})
  }

  onClaim = (params = {}) => {
    if (params.type === 'none') {
      return
    }

    if (!this.props.loading_unclaimed_backlog) {
      this.props.onClick(params.type, params)
    }
  }

  renderGroup = (type, label, highlighted, title) => {
    return (
      <div className="ml-2 flex w-[253px] overflow-hidden rounded-md shadow-sm">
        <button type="button" className={cn(BTN_CLASS, 'min-w-0 flex-1 gap-1.5', highlighted && HIGHLIGHT_CLASS)} onClick={() => {this.onClaim({type: type})}} title={title}>
          {label}
        </button>
        <button type="button" className={cn(BTN_CLASS, 'shrink-0 border-l border-white/25', highlighted && HIGHLIGHT_CLASS, highlighted && 'border-black/15')} onClick={() => {this.onClaim({type: type, newTab: true})}} title="Open claim in new tab">
          <ExternalLink className="size-4" />
        </button>
      </div>
    )
  }

  render() {
    if (this.props.loading_unclaimed_backlog) {
      return (
        <div className="flex w-[253px] overflow-hidden rounded-md shadow-sm">
          <button type="button" className={cn(BTN_CLASS, 'w-full')}>
            <LoaderCircle className="size-4 animate-spin" />
          </button>
        </div>
      )
    }

    const backlog = this.props.backlog || {}
    const next_item = backlog.next_item || {}

    if (!next_item.item_type) {
      return (
        <div className="flex w-[253px] overflow-hidden rounded-md shadow-sm">
          <button type="button" className={cn(BTN_CLASS, 'w-full p-0')} onClick={() => {this.onClaim({type: 'none'})}}>
            <img className="h-full" src="https://tm2-assets.ams3.cdn.digitaloceanspaces.com/system/assets/sales/images/you-win.webp" title={`You win the backlog`} />
          </button>
        </div>
      )
    }

    if ((next_item.highlight || '') == 'task') {
      return this.renderGroup('task', <span className="truncate">{next_item.label}</span>, true)
    }

    if ((next_item.highlight || '') == 'call_new_enquiry') {
      return this.renderGroup(
        'call',
        <React.Fragment><Phone className="size-4 shrink-0" /> <span className="truncate">Call new enquiry</span></React.Fragment>,
        true
      )
    }

    return this.renderGroup(
      'default',
      <span className="truncate">Claim ({backlog.unclaimed_items_count || 0})</span>,
      (next_item.highlight || '').length > 0,
      "Claim the next item in the queue that you're assigned to."
    )
  }
}

export default BacklogClaimButton
